import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

//STYLES
import * as NavBarStyles from "./styles/navBar";

//ACTIONS
import * as NavBarActions from "../../../envStore/actions/navBar";

function NavBar() {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const navBarSettings = useSelector((state) => state.navBar);

    const [sideMenuPosition, setSideMenuPosition] = useState(-210);
    const dispatch = useDispatch();

    const [hover, setHover] = useState({
        home: NavBarStyles.navButton,
        meetTheTeam: NavBarStyles.navButton,
        servicesAndEvents: NavBarStyles.navButton,
        community: NavBarStyles.navButton,
        links: NavBarStyles.navButton,
        contactUs: NavBarStyles.navButton
    });

    const [mobileNarBarShow, setMobileNavBarShow] = useState(false);

    function handleMouseEnter(event) {
        const { id } = event.target;

        setHover((prevState) => {
            return { ...prevState, [id]: NavBarStyles.navButtonHover };
        });
    }

    function handleMouseLeave(event) {
        const { id } = event.target;

        setHover((prevState) => {
            return { ...prevState, [id]: NavBarStyles.navButton };
        });
    }

    function toggleMobileMenu() {
        if (!mobileNarBarShow) {
            setMobileNavBarShow(true);
        } else {
            setMobileNavBarShow(false);
        }
    }

    function setSitePosition(position) {
        dispatch(NavBarActions.UpdateSitePosition(position));
    }

    function setPositionFromMobileNav(position) {
        dispatch(NavBarActions.UpdateSitePosition(position));
        setMobileNavBarShow(false);
    }

    function sideMenuUnderOnEnter() {
        setSideMenuPosition(0);
    }

    function sideMenuUnderOnLeave() {
        setSideMenuPosition(-210);
    }

    const browserNavBar = (
        <div style={{ position: "relative" }}>
            <div style={NavBarStyles.underSideNav} onMouseEnter={sideMenuUnderOnEnter} onMouseLeave={sideMenuUnderOnLeave}></div>
            <div
                style={{ ...NavBarStyles.sideNavBar, right: `${sideMenuPosition}px` }}
                onMouseEnter={sideMenuUnderOnEnter}
                onMouseLeave={sideMenuUnderOnLeave}
            >
                <div
                    style={navBarSettings.sitePosition == 0 ? NavBarStyles.navButtonSelected : hover.home}
                    id="home"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={setSitePosition.bind(this, 0)}
                >
                    Home
                </div>
                <div
                    style={navBarSettings.sitePosition == -100 ? NavBarStyles.navButtonSelected : hover.meetTheTeam}
                    id="meetTheTeam"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={setSitePosition.bind(this, -100)}
                >
                    Meet The Team
                </div>
                <div
                    style={navBarSettings.sitePosition == -200 ? NavBarStyles.navButtonSelected : hover.servicesAndEvents}
                    id="servicesAndEvents"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={setSitePosition.bind(this, -200)}
                >
                    Services and Events
                </div>
                <div
                    style={navBarSettings.sitePosition == -300 ? NavBarStyles.navButtonSelected : hover.community}
                    id="community"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={setSitePosition.bind(this, -300)}
                >
                    Community
                </div>
                <div
                    style={navBarSettings.sitePosition == -400 ? NavBarStyles.navButtonSelected : hover.links}
                    id="links"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={setSitePosition.bind(this, -400)}
                >
                    Links
                </div>
                <div
                    style={navBarSettings.sitePosition == -500 ? NavBarStyles.navButtonSelected : hover.contactUs}
                    id="contactUs"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={setSitePosition.bind(this, -500)}
                >
                    Contact Us
                </div>
            </div>
        </div>
    );

    const mobileNavBar = (
        <div style={{ position: "relative" }}>
            <div style={NavBarStyles.topNavBar}>
                <div style={NavBarStyles.topBar} onClick={toggleMobileMenu}>
                    <div style={NavBarStyles.topBarIcon}>
                        <i className="fa-solid fa-bars fa-2xl"></i>
                    </div>
                </div>
            </div>
            {mobileNarBarShow && (
                <div style={NavBarStyles.mobileNav_navBody}>
                    <div
                        style={
                            navBarSettings.sitePosition == 0
                                ? { ...NavBarStyles.mobileNav_navButtonSelected, borderRadius: "25px 0 0 0" }
                                : { ...NavBarStyles.mobileNav_navButton, borderRadius: "25px 0 0 0" }
                        }
                        onClick={setPositionFromMobileNav.bind(this, 0)}
                    >
                        Home
                    </div>
                    <div
                        style={navBarSettings.sitePosition == -100 ? NavBarStyles.mobileNav_navButtonSelected : NavBarStyles.mobileNav_navButton}
                        onClick={setPositionFromMobileNav.bind(this, -100)}
                    >
                        Meet the Team
                    </div>
                    <div
                        style={navBarSettings.sitePosition == -200 ? NavBarStyles.mobileNav_navButtonSelected : NavBarStyles.mobileNav_navButton}
                        onClick={setPositionFromMobileNav.bind(this, -200)}
                    >
                        Services and Events
                    </div>
                    <div
                        style={navBarSettings.sitePosition == -300 ? NavBarStyles.mobileNav_navButtonSelected : NavBarStyles.mobileNav_navButton}
                        onClick={setPositionFromMobileNav.bind(this, -300)}
                    >
                        Community
                    </div>
                    <div
                        style={navBarSettings.sitePosition == -400 ? NavBarStyles.mobileNav_navButtonSelected : NavBarStyles.mobileNav_navButton}
                        onClick={setPositionFromMobileNav.bind(this, -400)}
                    >
                        Links
                    </div>
                    <div
                        style={
                            navBarSettings.sitePosition == -500
                                ? { ...NavBarStyles.mobileNav_navButtonSelected, borderRadius: "0 0 0 25px" }
                                : { ...NavBarStyles.mobileNav_navButton, borderRadius: "0 0 0 25px" }
                        }
                        onClick={setPositionFromMobileNav.bind(this, -500)}
                    >
                        Contact Us
                    </div>
                </div>
            )}
        </div>
    );

    return <div>{GS_generalSettings.isMobile ? mobileNavBar : browserNavBar}</div>;
}

export default NavBar;
